/* scroll-snap.js - vanilla JS */
(function () {
  const container = document.getElementById('snap-container');
  if (!container) return;

  let isScrolling = false;
  let touchStartY = 0;
  const sections = Array.from(container.querySelectorAll('.snap-section'));

  function clampIndex(i) {
    return Math.max(0, Math.min(sections.length - 1, i));
  }

  function indexOfCurrent() {
    // calcule l'index de la section la plus proche du top visible
    const containerTop = container.scrollTop;
    let best = 0;
    let bestDiff = Infinity;
    sections.forEach((s, idx) => {
      const offset = s.offsetTop;
      const diff = Math.abs(offset - containerTop);
      if (diff < bestDiff) {
        bestDiff = diff;
        best = idx;
      }
    });
    return best;
  }

  function scrollToIndex(idx) {
    idx = clampIndex(idx);
    const target = sections[idx];
    if (!target) return;
    isScrolling = true;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // durée approximative — on remet isScrolling à false après 700ms
    setTimeout(() => { isScrolling = false; }, 700);
  }

  // wheel handler (debounced)
  container.addEventListener('wheel', (e) => {
    if (isScrolling) { e.preventDefault(); return; }
    const delta = e.deltaY;
    if (Math.abs(delta) < 10) return;
    e.preventDefault();
    const current = indexOfCurrent();
    if (delta > 0) scrollToIndex(current + 1);
    else scrollToIndex(current - 1);
  }, { passive: false });

  // keyboard navigation
  window.addEventListener('keydown', (e) => {
    if (isScrolling) return;
    // ignore when user typing in input/textarea
    const tag = document.activeElement && document.activeElement.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || document.activeElement.isContentEditable) return;

    const cur = indexOfCurrent();
    switch (e.key) {
      case 'ArrowDown':
      case 'PageDown':
        e.preventDefault(); scrollToIndex(cur + 1); break;
      case 'ArrowUp':
      case 'PageUp':
        e.preventDefault(); scrollToIndex(cur - 1); break;
      case 'Home':
        e.preventDefault(); scrollToIndex(0); break;
      case 'End':
        e.preventDefault(); scrollToIndex(sections.length - 1); break;
      default: break;
    }
  });

  // touch handling (simple)
  container.addEventListener('touchstart', (e) => {
    touchStartY = e.touches[0].clientY;
  }, { passive: true });

  container.addEventListener('touchend', (e) => {
    if (isScrolling) return;
    const touchEndY = (e.changedTouches && e.changedTouches[0].clientY) || 0;
    const diff = touchStartY - touchEndY;
    if (Math.abs(diff) < 40) return; // swipe trop petit
    const cur = indexOfCurrent();
    if (diff > 0) scrollToIndex(cur + 1);
    else scrollToIndex(cur - 1);
  }, { passive: true });

  // évite le problème quand contenu change dynamiquement (images lazy)
  window.addEventListener('resize', () => {
    // rien de spécial, mais recalcul si besoin
  });

  // optional: expose API
  window.snapScroll = {
    next: () => scrollToIndex(indexOfCurrent() + 1),
    prev: () => scrollToIndex(indexOfCurrent() - 1),
    to: (i) => scrollToIndex(i)
  };
})();
